// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"IbOYP","inner":"_33I_X","citat":"_1EHmY","innerstrong":"_1dgoh","citatstrong":"_3BVKw","av":"_1C0rV"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Citat/Citat.scss
 ** module id = 439
 ** module chunks = 0
 **/